<template>
  <!-- <Transition name="showNodeInfomation"> -->
    <div class="nodeInfo" v-show="flipStatus">
      <div class="slideWrap">
        <h3 class="name" :class="itemType.toLowerCase()">{{itemText}}</h3>
        <div v-for="(prop,index) in sortedProcessPropList.filter(prop => prop.active)" :key="prop.processPropertyId" class="node_result_box">
          <h4 class="site_detail_tit">
            속성명 : {{prop.propertyName}}
            <div v-if="prop.propertyDefine != null && prop.propertyDefine != ''" v-b-toggle="`sidebar-collapse-${index}`"
                 class="tooltip_box" title="속성설명을 보려면 클릭해주세요.">
              <span class="tooltip_ico"></span>
            </div>
          </h4>
          <h4 class="site_detail_con">단위 : {{prop.propertyUnit != null && prop.propertyUnit != ""? prop.propertyUnit : "없음"}}
            | 타입 : {{prop.propertyType != null? Object.values(PROPERTY_TYPE).find(item => item.value==prop.propertyType)?.label : "-"}}
          </h4>
          <h4 class="custom_site_detail_con" v-if="!strIsNull(prop.propertyVocabulary?.code)">
            어휘번호 :
            {{createViewVocabularyString(prop.propertyVocabulary)}}
          </h4>
          <h4 class="custom_site_detail_con" v-if="!strIsNull(prop.propertyClass?.name)">class :
            {{prop.propertyClass?.name}}
          </h4>
          <div v-if="prop.propertyDefine != null && prop.propertyDefine != ''">
            <b-collapse :id="`sidebar-collapse-${index}`" class="mt-2" style="cursor:default">
              <b-card @click.stop>
                <p style="white-space: pre-line; text-align: left;font-size: 13px; font-weight: bold; margin: 10px">
                  {{ prop.propertyDefine }}</p>
              </b-card>
            </b-collapse>
          </div>
        </div>

        <button class="flip" @click="menuFlip">접기</button>
      </div>
    </div>
  <!-- </Transition> -->
  
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import CommNew, {commNewMapGetters} from "@processEditor/CommNew";
import {PROPERTY_TYPE} from '@/util/HubHandsonTable';
// import mixin from "@/mixins/tag";
import ItemAddPopup from './itemAddPopup'
const Hub = createNamespacedHelpers('Hub');
const ProcessEditor = createNamespacedHelpers('ProcessEditor');

export default {
data(){
  return {
    diagram: {},
    itemText : '',
    itemCategory : '',
    itemType : '',
    selectItemInfo: {},
    editType: null,
    tagMemo: null,
    processPropList : [],
    PROPERTY_TYPE: PROPERTY_TYPE,
  }
},
mixins: [CommNew],
components:{
  ItemAddPopup
},
computed: {
  ...commNewMapGetters(['DIAGRAM']),
  ...ProcessEditor.mapGetters(['getSelectedNode', 'getProcessId', 'getDiagram']),
  flipStatus () {
    // console.log('Flip status : ', this.status.nodeinfoViewBln)
    return this.status.nodeinfoViewBln ; 
  } ,
  sortedProcessPropList(){
    //console.log(`[SideBar]sortedProcessPropList = `,this.processPropList.sort((a, b) => a.propertyOrder - b.propertyOrder));
    return this.processPropList.sort((a, b) => a.propertyOrder - b.propertyOrder);
  },
},
async mounted () {
  this.setTagInfoCommand({
    getTagInfomation : this.getTagInfomation
  }) ; 
},
watch: {
  DIAGRAM(diagram) {
    this.diagram = diagram
  },
  getSelectedNode: {
    async handler (value) {
      // console.log('Node select : ', value)
      if( this.diagram.selection.size === 1) {
        this.getTagInfomation(value)
      } else {
        // 노트 선택 시 정보 숨김 
        // this.updateStatus({ nodeinfoViewBln : false }) ; 
        this.clearInfo();
      }
    }
  },
},
methods : {
  ...ProcessEditor.mapMutations(['selectNode', 'setTagInfoCommand']),
  async getTagInfomation (nodeInfomation) {
    // console.log('Get infomation :', nodeInfomation)
    if(!nodeInfomation.tagId) {
      this.updateStatus({ nodeinfoViewBln : false }) ;
      return
    }
    switch (nodeInfomation.visible) {
      case true:
        this.updateStatus({ nodeinfoViewBln : true }) ;
        break;
      case false:
        this.updateStatus({ nodeinfoViewBln : false }) ;
        break;
      default:
        break;
    }
    this.itemType = nodeInfomation.category;
    this.itemText = nodeInfomation.text;
    const response = await this.$wApi.dictionary.getDictionaryKeyLinkByProcessIdAndKey({
      key: nodeInfomation.key,
      processId: this.$route.query.processId
    });
    if(this.$route.query.menuType=='manager'){
      this.processPropList = await this.$wApi.property.getProcessPropertyList({
        dictionaryKeyLinkId : response.id
        ,processId : this.$route.query.processId
      });
    }else if(this.$route.query.menuType=='researcher'){
      this.processPropList = await this.$wApi.property.getReleaseProcessPropertyList({
        dictionaryKeyLinkId : response.id
        ,processId : this.$route.query.processId
      });
    }
  },
  show () {
    this.editType = 'add'
    this.tagInfoData = {}
    this.tagInfoData.tagInfoId = !this.tagInfoList ? 0 : this.tagInfoList.length
    this.popupStatus = true; 
  },
  hide () {
    this.popupStatus = false; 
  },
  menuFlip () {
    // this.flipStatus = true;
    this.updateStatus({ nodeinfoViewBln : false }) ; 
    this.selectNode({}, false);
  },
  clearInfo() {
    this.itemType = '';
    this.itemText = '';
    this.tagMemo = '';
    this.itemType = '';
    this.selectShapeName = '';
    this.tagInfoList = [];
    this.processPropList = [];
  },
  strIsNull(string){
    return string == null || string == ""
  },
  createViewVocabularyString(propertyVocabulary){
    let result = "";
    if(propertyVocabulary == null){
      return result;
    }
    result += propertyVocabulary.code + "(";
    if(propertyVocabulary.system1 != null && propertyVocabulary.system1){
      result += propertyVocabulary.system1;  
    }
    if(propertyVocabulary.system2 != null && propertyVocabulary.system2){
      result += " / " + propertyVocabulary.system2;   
    }
    result += ")";
    return result;
  }
}
}

</script>

<style lang="scss" scoped>
  
  div.nodeInfo {
    overflow: auto;
    overflow-x: hidden;
    @include scrlbar;
    grid-area: aside;
    position: relative;
    max-width: 270px;
    border-left: 1px solid #999;
    background-color: $white;
    // transform: translate(0,0);
    .slideWrap {
      position: relative;
      box-sizing: border-box;
      align-items: flex-start;
      min-width: var( --nodeinfo-width ); 
      background: $white;
      padding: 0 var( --default-gap );
    }
    .name {
      display: flex; align-items: center;
      min-height: 40px;
      padding: 10px 70px 10px var( --default-gap );
      margin: 0 calc( var( --default-gap ) * -1 ); 
      border-bottom: 1px solid #999;
      font-size: 16px;
      @include text-prt-eb;
      &.material { color: black }
      &.process { color: black }
      &.analysis  { color: black }
      &.measurement  { color: black }
    }
    button.flip, button.open { 
      display: flex; align-items: center;
      position: absolute; top:10px; right: var( --default-gap );
      &:after {
        content:'';
        display: inline-block;
        width: 10px; height: 10px;
        margin-left: 7px;
        background: url('../../../assets/icons/expand_right.svg') 0 0 no-repeat;
      }
      color: #999;
    }
    button.open {
      top: 60px;
      white-space: nowrap;
      z-index: -1;
      &:after {
        background: url('../../../assets/icons/expand_left.svg') 0 0 no-repeat;
      }
    }
    caption, h3 {
      $paddingTB: 10px;
      $paddingLR: var( --default-gap );
      caption-side: top;
      padding: $paddingLR $paddingTB 0 0;
      margin-bottom: 8px;
      text-align: left;
      font-size: 16px;
      color: #333;
      @include text-prt-eb;
    }
    table {
      $paddingTB: 10px;
      $paddingLR: var( --default-gap );
      padding: $paddingLR $paddingTB;
      tr {
        padding: $paddingLR $paddingTB;
        &:hover {
          cursor: pointer;
          td {
            background-color: #eee;
          }
        }
      }
      th {
        padding: 10px;
        background-color: #eee;
        color: #666;
        border: 1px solid #999;
        text-align: left;
        white-space: nowrap;
        
      }
      td {
        position: relative;
        width: 100%;
        padding: 10px;
        border: 1px solid #999;
       
        
        > p {
          display: -webkit-box;
          max-width: 120px;
          line-height: 1.2em;
          overflow: hidden;
          word-wrap: break-word;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        span {
          display: block;
          cursor: pointer;
        }
        &:hover {
          .editInfo { visibility: visible; }
        }
      }
      &.item {
        td:first-child {
          width: 30%
        }
      }
      .editInfo {
        visibility: hidden;
        display: flex;
        gap: 5px;
        position: absolute; top: 10px; right: 7px;
        button {
          font-size:0;
          opacity: .5;
          &:hover { opacity: 1;}
          &.edit {
            width: 14px; height: 14px; 
            background: url('../../../assets/icons/pencil.svg') center no-repeat
          }
          &.delete {
            width: 14px; height: 14px; 
            background: url('../../../assets/icons/icon-close.svg') center no-repeat
          }
        }
      }
    }
    .shapes {
      display: flex; flex-direction: column;
      position: absolute;
      min-width: 100px;
      border: 1px solid #999;
      background-color: $white;
      z-index: 1;
      li {
        display: flex; align-items: center;
        padding: 10px;
        cursor: pointer;
        &:before {
          content:'';
          display: block;
          width: var( --default-gap ); height: var( --default-gap );
          margin-right: 5px;
          filter: brightness(0.4);
          background-position: center;
          background-repeat: no-repeat;
          background-size: 100%;
        }
        &.bulk::before { background-image: url('../../../assets/protocol/bulk.svg')}
        &.powder::before { background-image: url('../../../assets/protocol/powder.svg')}
        &.liquid::before { background-image: url('../../../assets/protocol/liquid.svg')}
        &.foil::before { background-image: url('../../../assets/protocol/foil.svg')}
        &:hover { background-color: #eee; }
      }
    }
    .addContent {
      display: flex; align-items: center; justify-content: center;
      padding: var( --default-gap );
      gap: 10px;
      font-size: 14px;
      @include text-prt-b;
      color: #666;
      text-align: center;
      cursor: pointer;
      &:before {
        content:'';
        display: block;
        width: 10px; height: 10px;
        background: url('../../../assets/icons/icon-plus.svg') center no-repeat;
      }
    }

    .memo {
      textarea {
        width: 100%;
        min-height: 150px;
        padding: 8px;
        resize: none;
      }
    }
    &.showNodeInfomation-enter-active {
      transform: translate(100%,0);
      transition: transform .3s ease;
    }
    &.showNodeInfomation-leave-active {
      transition: transform .3s ease;
    }
    &.showNodeInfomation-enter-to {
      transform: translate(0,0)
    }
    &.showNodeInfomation-leave-to {
      transform: translate(100%,0)
    }
  }
  @keyframes flipAside {
    0% { width: auto; transform: translate(0, 0) }
    100% { width: auto; transform: translate(100%, 0) }
  }
  @keyframes openAside {
    0% { width: auto; transform: translate(100%, 0) }
    100% { width: auto; transform: translate(0, 0) }
  }
  .node_result_box {border:1px solid #ccc;background:#fff;padding:0 12px 12px 12px; margin-top:5px;position:relative;}
  .node_result_box_btn {position:absolute;top:0px;right:0;}
  .node_result_box_btn a {margin-left:1px;}
  .node_result_box .site_detail_tit {margin-top:12px;}
  .site_detail_tit {margin-top:20px;position:relative;padding-left:10px; font-size:14px;color:#111;font-family:"Noto Sans KR Bold";}
  .site_detail_tit:before {position:absolute;content:'';left:0;top:4px; width:3px;height:12px;background:#111;}
  .site_detail_con {margin-top:10px;font-size:14px;line-height:24px;color:#555;font-family:"Noto Sans KR Medium";}
  .site_detail_con label {padding-left:3px;}
  
  .custom_site_detail_con { color: #555; font-family: "Noto Sans KR Medium"; font-size: 14px; line-height: 24px;}
</style>

